import React from "react";

const EngineSVG: React.FunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    data-testid="engine"
  >
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      d="M13.75 8.625c.29 0 .525-.25.525-.563 0-.311-.234-.562-.525-.562h-4.2c-.29 0-.525.25-.525.563 0 .311.234.562.525.562h1.575v.75H7.8c-.387 0-.7.335-.7.75v1.313H6.05V9.75c0-.312-.234-.563-.525-.563-.29 0-.525.251-.525.563v4.5c0 .312.234.563.525.563.29 0 .525-.251.525-.563v-1.688H7.1v1.688c0 .415.313.75.7.75h.98l.7.938c.265.356.667.562 1.094.562H14.8c.772 0 1.4-.673 1.4-1.5v-3.403c0-.455-.192-.886-.525-1.172l-.842-.722a1.336 1.336 0 0 0-.875-.328h-1.783v-.75h1.575ZM17.6 10.5c-.387 0-.7.335-.7.75v4.5c0 .415.313.75.7.75h.7c.387 0 .7-.335.7-.75v-4.5c0-.415-.313-.75-.7-.75h-.7Z"
      fill="#1D2948"
    />
  </svg>
);

export default EngineSVG;
